export const EXPAND_BUTTON_HEIGHT = 24

export const CLAMPING_LINES_COUNT = 2
